import { useEffect, useRef, useState } from 'react';
import { haptic } from '../lib/telegram';

/**
 * The "⋯" on a row.
 *
 * Anything that destroys something lives in here rather than sitting on
 * the card as a red button: removing a package or cancelling a session
 * is a thing you go looking for, not a thing your thumb finds while
 * scrolling. The destructive item still confirms after it is chosen.
 */
export function RowMenu({ items, label }: {
  items: { label: string; onSelect: () => void; danger?: boolean }[];
  label: string;
}) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const away = (e: MouseEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', away);
    return () => document.removeEventListener('mousedown', away);
  }, [open]);

  return (
    <div className="rowmenu" ref={box}>
      <button className="rowmenu__dots" aria-label={label} aria-expanded={open}
        onClick={() => { haptic.tap(); setOpen(!open); }}>⋯</button>
      {open && (
        <div className="rowmenu__list" role="menu">
          {items.map((it) => (
            <button key={it.label} role="menuitem"
              className={`rowmenu__item${it.danger ? ' rowmenu__item--danger' : ''}`}
              onClick={() => { haptic.tap(); setOpen(false); it.onSelect(); }}>
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
